export default "<div ui-view=\"menu\" class=\"gsapify-router\"></div><div ui-view=\"content\" scroll-recall class=\"gsapify-router\"></div>";